import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';

import { Image } from './utils/lazyImage';

import Styles from '../styles/components/featured.module.scss';
const { container, title: featuredTitle } = Styles;

class Featured extends React.PureComponent {
  render() {
    const { image, title, link } = this.props;

    const article = (
      <article className={container}>
        <Image sizes={image} alt={title} />
        <h2 className={featuredTitle}>{title}</h2>
      </article>
    );

    return link ? <Link to={link}>{article}</Link> : article;
  }
}

export default Featured;



// WEBPACK FOOTER //
// ./src/components/featured.js